import type { ReactNode } from 'react';

import SortSm from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/sort';
import BpkInfoBanner from '@skyscanner-internal/backpack-web/bpk-component-info-banner';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import BottomSheetChip from '../BottomSheetChip';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type {
  SortingLinksProps,
  ToolTip,
} from '@skyscanner-internal/landing-pages-shared-types/types-shared/SortingLinkts';

import STYLES from './SortingLinksMobile.module.scss';

type SortingLinksMobileProps = {
  label: string;
} & SortingLinksProps;

const SortingLinksMobile = ({
  label,
  links,
  sortingTitle,
}: SortingLinksMobileProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = `${rawComponentName}_sort`;
  const bannerList: ReactNode[] = [];

  function addBanner({ descriptions, title }: ToolTip) {
    const message = (
      <>
        <BpkText tagName="h5" textStyle={TEXT_STYLES.heading5}>
          {title}
        </BpkText>
        <div className={STYLES.SortingLinksMobile__BannerMessage}>
          {descriptions.map((description) => (
            <BpkText
              tagName="p"
              key={description}
              textStyle={TEXT_STYLES.footnote}
            >
              {description}
            </BpkText>
          ))}
        </div>
      </>
    );
    bannerList.push(<BpkInfoBanner message={message} type="info" />);
  }

  return (
    <BottomSheetChip
      id="SortingLinksMobile"
      label={label}
      title={sortingTitle}
      icon={<SortSm />}
      trackingElementId={`${mbdComponentName}_open_mobile`}
      trackingCommonParams={buildMBDParam(mbdComponentName, {
        sort_name: 'open',
      })}
    >
      <div className={STYLES.SortingLinksMobile__LinkList}>
        {links.map(({ text, toolTip, url }, index) => {
          if (toolTip) {
            addBanner(toolTip);
          }

          return (
            <BpkLink
              key={text}
              href={url}
              data-tracking-element-id={`${mbdComponentName}_mobile_${index}`}
              data-tracking-common-params={buildMBDParam(mbdComponentName, {
                sort_name: text.slice(0, 40),
              })}
            >
              {text}
            </BpkLink>
          );
        })}
      </div>
      {bannerList.length > 0 && (
        <div className={STYLES.SortingLinksMobile__BannerList}>
          {bannerList}
        </div>
      )}
    </BottomSheetChip>
  );
};

export default SortingLinksMobile;
